<template>
    <div class="cart-bottom">
        <p class="accept-methods">
            <span>{{ $t('cart.bottom.accept') }}</span>
            <img v-for="(item, index) in paymentMethods.all"
                :key="index"
                :src="getPaymentImage(item)"
                :alt="$tc(`cart.credit_cart.${index}`)"
                :title="$tc(`cart.credit_cart.${index}`)">
        </p>
        <div class="security-content-wrap">
            <div class="flex security-content">
                <div>
                    <i class="icon-icon2_security security-icon"></i>
                </div>
                <div>
                    <h3 class="security-title">{{ $t('cart.bottom.ssl') }}</h3>
                    <p class="security-des">{{ $t('cart.bottom.security') }}</p>
                    <p class="privacy"
                        v-html="$t('cart.bottom.privacy', {
                            privacy: getOfficialUrl( config.privacy )
                        })"></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import paymentMethods from '@/config/paymentMethods';
import { config } from 'CONFIG';

export default Vue.extend({
    data () {

        return {

            paymentMethods,
            config

        };

    }
});
</script>

<style lang="less">
    @s-color: #007400;
    .reo-cart{
        .cart-bottom{
            padding-top: 0.2rem;
            border-top: 1px solid @line;
            @media @snapeak_mobile {
                padding: 0;
                border: none;
            }
            .accept-methods{
                font-size: 0.16rem;
                color: @font_primary;
                margin-bottom: 0.25rem;
                @media @snapeak_mobile {
                    border-top: 1px solid @line;
                    font-size: 0.26rem;
                    margin: 0 15px;
                    padding: 0.35rem 0;
                }
                span{
                    margin-right: 0.2rem;
                    display: inline-block;
                }
                img{
                    vertical-align: middle;
                    @media @snapeak_mobile{
                        max-width: 66px;
                        width: 0.65rem;
                    }
                }
                img+img{
                    margin-left: 0.1rem;
                }
            }
            .security-icon{
                color: @s-color;
                font-size: 0.5rem;
                margin-right: 0.15rem;
                @media @snapeak_mobile{
                    font-size: 0.6rem;
                }
            }
            .security-title{
                color: @s-color;
                font-size: 0.14rem;
                line-height: 1;
                @media @snapeak_mobile{
                    font-size: 0.26rem;
                    margin-bottom: 0.1rem;
                }
            }
            .security-des{
                @media @snapeak_mobile{
                    font-size: 0.22rem;
                    font-weight: 300;
                }
            }
            .privacy{
                color: @font_secondary;
                margin-top: 0.05rem;
                @media @snapeak_mobile{
                    font-size: 0.22rem;
                    font-weight: 300;
                    margin-top: .1rem;
                }
            }
            @media @snapeak_mobile {
                .security-content{
                    padding: 0.6rem 0 0.35rem;
                }
                .security-content-wrap{
                    padding: 0 15px;
                }
            }
        }
    }
    .body.app-not-show .security-content-wrap{
        padding-bottom: 1rem;
    }
    .accept-methods img {
        width: 36px;
        @media @snapeak_mobile {
            width: 0.36rem;
        }
    }
</style>
